import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

import { BookingBase } from '../booking.base';
import { GoogleAnalyticsService } from 'src/app/services/common/google-analytics.service';

@Component({
    selector: 'booking-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent extends BookingBase implements OnInit {
  
  constructor(
    protected deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    super(deviceService)
  }

  ngOnInit(): void {
    if (!this.route.snapshot.queryParams.paymentStripe) {
      this.googleAnalyticsService.trackEvent('view_payment_page', {
        page_title: 'Payment',
        customer_type: 'new'
      }).catch(error => console.error('AddGa4Event view_payment_page failed: ', error));
    }
  }

}
